<template>
  <div class="registerPatient">
    <edit-patient/>
  </div>
</template>
<script>
import EditPatientVue from "../components/EditPatient.vue";
export default {
  name: "RegisterPatient",
  components: {
    "edit-patient": EditPatientVue
  },
  computed: {},
  methods: {}
};
</script>

<style>
</style>

